module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabrielsTrail_BW-p-1080-5c640f8281200dba2f8a8c32a222e66a.jpg";